export default __webpack_public_path__ + "static/media/offer_banner_graphic.4cf6c480.png";